"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const sizes = {
  XL: {
    L: 256,
    M: 192,
    S: 96
  },
  L: {
    L: 128,
    M: 96,
    S: 48
  },
  M: {
    L: 96,
    M: 64,
    S: 32
  },
  S: {
    L: 40,
    M: 32,
    S: 20
  },
  XS: {
    L: 28,
    M: 28,
    S: 16
  }
};
const Block = _styledComponents.default.div`
  height: 100%;
  min-height: ${props => sizes[props.paddingSize || 'S'].S}px;

  @media (min-width: 768px) {
    min-height: auto;
    min-width: ${props => sizes[props.paddingSize || 'S'].M}px;
  }

  @media (min-width: 1200px) {
    min-width: ${props => sizes[props.paddingSize || 'S'].L}px;
  }
`;
const Separator = ({
  paddingSize
}) => {
  return _react.default.createElement(Block, {
    paddingSize: paddingSize
  });
};
var _default = Separator;
exports.default = _default;
//# sourceMappingURL=Separator.js.map